<template>
    <div class="content">
        <h2>处罚案卷目录</h2>
        <div style="height:580px;overflow-y:auto;">
        <el-table :data="mlList">
            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                <template slot-scope="scope">
                    <span>{{scope.$index+1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="排序" align="center" prop="xuhao" width="60"  >
                <template slot-scope="scope">
                    <span style="position:relative; width:28px;height: 40px;float: left;">
                        <span style="position: absolute;width: 28px;height: 15px;"><i @click="GoUp(scope.$index)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-top"></i></span>
                        <span style="position: absolute;width: 28px;height: 15px;top: 15px;z-index: 2;"><i @click="Godown(scope.$index)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-bottom"></i></span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="题名" align="center" prop="name" >
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.name"
                        placeholder=""
                        clearable
                        size="small"
                        />
                    
                </template>
            </el-table-column>
            <el-table-column label="文号" align="center" prop="wenhao" width="190px" >
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.wenhao"
                        placeholder=""
                        clearable
                        size="small" :disabled="scope.row.isWh?false:true"
                        />
                </template>
            </el-table-column>
            <el-table-column label="责任者" align="center" prop="zerenzhe" width="200px" >
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.zerenzhe"
                        placeholder=""
                        size="small" :disabled="scope.row.isZrz?false:true"
                        />
                </template>
            </el-table-column>
            <el-table-column label="日期" align="center" prop="riqi" width="150px">
                <template slot-scope="scope">
                    <el-date-picker style="width:140px;"  class="ml"
                        v-model="scope.row.riqi"
                        type="date"
                        size="small" :disabled="scope.row.isRq?false:true"
                        placeholder="" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column label="页数" align="center" prop="yema" width="70px" >
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.yema"
                        placeholder=""
                        size="small" :disabled="scope.row.isYs?false:true"
                        />
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="100" >
                <template slot-scope="scope">
                    <el-button
                        size="small"
                        type="text"
                        @click="handleAdd(scope.row)"
                    >添加</el-button>
                    <el-button
                        size="small"
                        type="text"
                        @click="handleDelete(scope.$index)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <br/>
        <div>
            <el-button type="primary" @click="submit('form','0')">暂存</el-button>
            <el-button type="primary" @click="submit('form','1')">生成处罚案卷目录</el-button>
            <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
            <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
        </div>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="处罚案卷目录" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['code','pcId'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            mlList:[
                // {wsname:'aaa',wenhao:'测上卫传罚﹝2024﹞199号',zerenzhe:'测试市测试局卫生健康局',rq:'',yeshu:1},
                // {wsname:'送达回执',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'',yeshu:1},
                // {wsname:'案件受理记录',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'2024-05-11',yeshu:1},
                // {wsname:'立案报告',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'2024-05-11',yeshu:1},
                // {wsname:'现场笔录',wenhao:'2024-104022',zerenzhe:'测试市测试局卫生健康局',rq:'2024-05-09',yeshu:1},
                // {wsname:'卫生监督意见书',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'',yeshu:1},
                // {wsname:'询问笔录',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'',yeshu:2},
                // {wsname:'执法文书送达方式及地址确认书',wenhao:'',zerenzhe:'测试市测试局卫生健康局',rq:'',yeshu:1},
                // {wsname:'营业执照副本复印件',wenhao:'12340104MA28N8QF3C',zerenzhe:'',rq:'',yeshu:1},
                // {wsname:'卫生许可证复印件',wenhao:'测卫放证字[2024]第330104F00012号',zerenzhe:'',rq:'',yeshu:1},
            ],
            wsUrl:'',
            isWs:false,
            muluState:'',

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[]
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        this.getList()
    },
    methods: {
        async getList(){
            this.isWs = false
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('处罚案卷目录')}&xcblFlag=`)
            if(data.data){
                if(data.data == '1'){
                    this.isWs = true
                    //有
                    this.getZfxx()
                }else{
                    this.isWs = false
                }
                
            }
            //获取文书目录
            // var wenhaoDis = ['卫生许可证复印件', '营业执照副本复印件', '送达回执', '案件受理记录', '授权委托书', '立案报告', '询问笔录', '代理人身份证复印件', 
            //  '案件调查终结报告', '合议记录', '结案报告', '浙江省行政执法证复印件', '浙江省罚没财务专用票据',
            //     '法定代表人身份证复印件', '卫生行政执法事项审批书', '卫生行政执法事项审批表', '卫生监督意见书', '现场笔录', '浙江省行政执法证'];
            // var zrzDis = ['法定代表人身份证复印件', '代理人身份证复印件', '授权委托书', '浙江省罚没财务专用票据', '浙江省行政执法证复印件'];
            // var pageDis = ['送达回执', '案件受理记录', '立案报告', '卫生监督意见书', '营业执照副本复印件', '法定代表人身份证复印件', '授权委托书', '代理人身份证复印件', '现场笔录（复查）', '卫生许可证复印件', '浙江省罚没财务专用票据', '结案报告'];
            //var xwrq = ['营业执照副本复印件', '代理人身份证复印件', '法定代表人身份证复印件'] //, '被询问人身份证复印件'
            var wenhaoDis = ['行政处罚决定书','卫生监督投诉举报受理表', '现场笔录', '卫生监督意见书', '执法文书送达方式及地址确认书',
             '营业执照副本复印件', '卫生许可证复印件', '现场照片（图片、影像资料）证据', '现场笔录（复查）', '卫生行政执法事项审批表(事先告知)',
              '行政处罚事先告知书', '卫生行政执法事项审批表(行政处罚)', '浙江省行政执法证复印件'];
            var zrzDis = ['营业执照副本复印件', '卫生许可证复印件', '法定代表人身份证复印件', '授权委托书', 
            '代理人身份证复印件', '经营者身份证复印件','浙江省罚没财务专用票据'];
            var pageDis = ['送达回执', '案件受理记录', '立案报告', '卫生监督意见书',
             '营业执照副本复印件','卫生许可证复印件','经营者身份证复印件', '法定代表人身份证复印件', '授权委托书',
              '代理人身份证复印件',  '浙江省罚没财务专用票据', '结案报告'];
            var xwrq = [ ]

            let data3 = await this.$axios.get(`${this.Global._baseUrl2}?act=getAnjianmuluNeirong&id=${this.pcId}`)
            console.log(data3.data)
            if(data3.data){
                if(data3.data.length > 0){
                    this.muluState = '1'
                    this.mlList = data3.data
                }
                // else if (JSON.parse(localStorage.getItem(pc_id))) {
                //     this.muluState = '2'; // 暂存
                //     //anjianmuluData = JSON.parse(localStorage.getItem(pc_id));
                // }
            }else{
                this.muluState = '3'
                let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getAnjianmulu&id=${this.pcId}&c_mid=${this.cmid}`)
                if(data2.data){
                    console.log(data2.data)
                    this.mlList = data2.data
                        // timingData = [];
                        //     var len = data.length;
                        //     for (var i = 0; i < len; i++) {
                        //         //针对多个名字的
                        //         if (data[i].name === '法定代表人身份证复印件') {
                        //             var name = data[i].name;

                        //             if (zfxx.jingyingzhe !== '') {
                        //                 if (zfxx.jingyingzhe === '法定代表人') {
                        //                     name = '法定代表人身份证复印件';
                        //                 } else {
                        //                     name = zfxx.jingyingzhe + '身份证复印件';
                        //                 }
                        //             } else {
                        //                 if (zfxx.reason1.indexOf('杭州市') === 0) {
                        //                     if (zfxx.reason1.indexOf('杭州市上城区') === 0) {
                        //                         name = '经营者身份证复印件';
                        //                     } else {
                        //                         name = '法定代表人身份证复印件';
                        //                     }
                        //                 }
                        //             }
                        //             timingData.push(name)
                        //         } else {
                        //             timingData.push(data[i].name);
                        //         }
                        //     }
                        //     listtabdata = data
                    }
            }
            this.mlList.forEach(item => {
                if(item.riqi == '1900/1/1 0:00:00' || item.riqi == ''){
                    item.riqi = ''
                }else{
                    item.riqi = this.getDate(item.riqi,'yyyy-MM-dd')
                }
                
                if(!item.yema){
                    item.yema = 1
                }
                item.isWh = false
                item.isZrz = false
                item.isRq = true
                item.isYs = false
                // console.log(wenhaoDis.includes(item.name))
                if(wenhaoDis.includes(item.name) == true){
                    item.isWh = true
                }else{
                    item.isWh = false
                }
                if(zrzDis.includes(item.name) == true){
                    item.isZrz = false
                }else{
                    item.isZrz = true
                }
                if(pageDis.includes(item.name) == true){
                    item.isYs = false
                }else{
                    item.isYs = true
                }
                // if(xwrq.includes(item.name) == true){
                //     item.isRq = false
                // }else{
                //     item.isRq = true
                // }
                // if (item.name === '法定代表人身份证复印件') {
                //     if (zfxx.jingyingzhe !== '') {
                //         if (zfxx.jingyingzhe === '法定代表人') {
                //             name = '法定代表人身份证复印件';
                //         } else {
                //             name = zfxx.jingyingzhe + '身份证复印件';
                //         }
                //     } else {
                //         if (zfxx.reason1.indexOf('杭州市') === 0) {
                //             if (zfxx.reason1.indexOf('杭州市上城区') === 0) {
                //                 name = '经营者身份证复印件';
                //             } else {
                //                 name = '法定代表人身份证复印件';
                //             }
                //         } else {
                //             name = v.name;
                //         }
                //     }
                // }
                // if (item.name === '法人代表身份证复印件') {
                //     item.name = '法定代表人身份证复印件'
                // }
                if(item.name == '浙江省罚没财务专用票据'){
                    item.name = '非税收入一般缴款书(电子)'
                }
            })
        },
        checkNum(num) {
            var reg = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/

            if (!reg.test(num)) {

                alert("请输入数字");

                return false;

            } else {
                return true;
            }
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=chufaanjuanmulu&sjs='+new Date().getTime()
                let nm = 'chufaanjuanmulu'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                 
            }
        },
        submit(form,val){
            let arr = [];
            // this.mlList.forEach(item => {
            //     if(item.isWh && !item.wenhao){
            //         arr.push(item)
            //     }
            //     if(item.isZrz && !item.zerenzhe){
            //         arr.push(item)
            //     }
            //     if(item.isYs && !item.yema){
            //         arr.push(item)
            //     }
            //     if(item.isRq && !item.riqi){
            //         arr.push(item)
            //     }
            // })
            if(arr.length > 0){
                this.$message.error(arr[0].name+'未填写完整!')
                return false
            }else{
                this.submit1(val)
            }
        },
        submit1(val){
            // this.$refs[form].validate((valid) => {
            //     if (valid) {
                    let that = this
                    this.mlList.forEach(item => {
                        if(item.name == "行政处罚决定书" && item.riqi == ''){
                            item.riqi = this.getDate(new Date(),'yyyy-MM-dd')
                        }
                    })
                    let nr = val+JSON.stringify(this.mlList)
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('处罚案卷目录'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:'',
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            //code: "1"
                            //data: "showpdf.html?mid=dw400&lsh=202400096&wsnameEw=weishengjianduyijianshu&sjs=20240625144456060"
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.wsUrl = res.data.data.split('?')[1]
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                // }
            // })
        },
        show(){
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        handleAdd(row){
            this.$prompt('文书题目', '添加文书', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '邮箱格式不正确'value
            }).then(({ value }) => {
                this.mlList.push({name:value,bz: "",px: "",riqi: "",wenhao: "",yema: "1",zerenzhe: "",isWh:true,isZrz:true,isRq:true,isYs:true})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        handleDelete(i){
            this.$confirm("确定要选择这条记录吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
            })
            .then(() => {
                this.mlList.splice(i,1)
            })
            .catch(() => {
            this.$message({
                type: "info",
                message: "已取消操作"
            });
            });
        },
        GoUp(i){
            console.log(i,133)
            if(i==0){
                this.$message.error('当前问题为第一个，不能前移。');
                return false;
            }
            this.move(this.mlList, i-1, i);
        },
        Godown(i){
            console.log(i,141)
            if(i==this.mlList.length-1){
                this.$message.error('当前问题为最后一个，不能后移。');
                return false;
            }
            this.move(this.mlList, i, i+1);
        },
        move(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            return arr;
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'chufaanjuanmulu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-table .el-input__inner{padding:0 10px;}
.content >>> .el-table .ml.el-input .el-input__inner{padding:0 15px 0 30px;}
</style>